import { z } from "zod/v4";

import { AudienceFilterDtoSchema } from "../../../../../dtos/audiences";

export const PluginAudienceFiltersSchema_2024_05_05 =
  AudienceFilterDtoSchema.omit({
    id: true,
  });

export type PluginAudienceFiltersType_2024_05_05 = z.infer<
  typeof PluginAudienceFiltersSchema_2024_05_05
>;
